// A click handler for an emergency's answer buttons that acts once per gesture.
//
// An answer takes its card or row off the screen on the click, and the next emergency slides into the
// spot under the pointer. So the second click of a double-click lands on a DIFFERENT worker's button,
// and would answer an emergency the operator has not even read. `detail` is the browser's own count
// of clicks in one burst (1 for a single click, 0 from the keyboard). Anything above 1 is the same
// gesture continuing, never a decision about the emergency that has just appeared.

export function singleClick(run: () => void): (event: { detail: number }) => void {
  return event => {
    if (event.detail > 1) return
    run()
  }
}
